import React, { useEffect } from 'react';

import { withRouter, RouteComponentProps } from 'react-router-dom';

import { setActiveProfileId } from '@/state/global/creators';
import { IState } from '@/state/IState';
import { connect } from 'react-redux';
import { CustomRedirect } from '@/components/navigation';
import { Dispatch } from 'redux';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';

const mapStateToProps = (state: IState) => ({ activeProfile: state.global.activeProfile });

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setActiveProfileId: (profileId: number) => setActiveProfileId(dispatch, profileId),
});

type IOwnProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & RouteComponentProps<any>;

const ProfileSwitcher = ({ match, activeProfile, setActiveProfileId }: IOwnProps) => {
    const urlProfileId = +match.params.profileId;

    useEffect(() => {
        if (!activeProfile || activeProfile.id !== urlProfileId) {
            setActiveProfileId(urlProfileId);
        }
    }, [urlProfileId, activeProfile, setActiveProfileId]);

    if (activeProfile && activeProfile.id === urlProfileId) {
        return <CustomRedirect to={'/' + (match.params.returnUrl || '')} />;
    }

    return <LoadingIndicator />;
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ProfileSwitcher));